import { IUserInfoDto } from "@kuika/kuika-cl-model";
import * as React from "react";
import { ScreenDesignContextProvider } from "../../contexts/screen-design-context/screen-design-context-provider";
import { IWithSDProps, withSD } from "../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../shared/hoc/with-history";
import { ScreenDesignTooltipListener } from "../onboarding-tooltip/screen-design-tooltip-listener";
import { DesignerDashboard } from "./designer-dashboard";

export interface IScreenDesignState {}

export interface IScreenDesignProps {}

class ScreenDesign extends React.PureComponent<
  IScreenDesignProps & IWithContextProp & IWithHistoryProp & IWithSDProps,
  IScreenDesignState
> {
  constructor(props: IScreenDesignProps & IWithContextProp & IWithHistoryProp & IWithSDProps) {
    super(props);
    this.state = { userInfo: {} as IUserInfoDto };
  }

  render() {
    return (
      <>
        <div className="kuika_resizeWrapper" />
        <ScreenDesignContextProvider context={this.props.context} navigator={this.props.navigator}>
          <ScreenDesignTooltipListener />
          <DesignerDashboard />
        </ScreenDesignContextProvider>
      </>
    );
  }
}

const screenDesign = withSD<IScreenDesignProps>(
  withContext<IScreenDesignProps>(
    withHistory<IScreenDesignProps & IWithSDProps & IWithContextProp & IWithHistoryProp>(ScreenDesign)
  )
);
export { screenDesign as ScreenDesign };
